import { render, staticRenderFns } from "./DefaultSchema.vue?vue&type=template&id=4b10fc38&"
import script from "./DefaultSchema.vue?vue&type=script&lang=ts&"
export * from "./DefaultSchema.vue?vue&type=script&lang=ts&"
import style0 from "./DefaultSchema.vue?vue&type=style&index=0&id=4b10fc38&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports